import React from 'react';
import PropTypes from 'prop-types';

import './ProductVariants.sass';

import ProductOptionsPicker, {applyOptions} from '../productPurchase/ProductOptionsPicker';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import RankPickerContainer from './rankPickers/RankPickerContainer';
import Pricing from '../pricing/Pricing';
import {FormattedMessage} from 'react-intl';

export default class RankCalculatorVariant extends React.PureComponent {
  static propTypes = {
    price: PropTypes.number,
    ranks: PropTypes.shape({
      displayType: PropTypes.string,
      minTotalCost: PropTypes.number,
      ranges: PropTypes.arrayOf(PropTypes.shape({
        start: PropTypes.number.isRequired,
        end: PropTypes.number.isRequired,
        rangePrice: PropTypes.number.isRequired,
        rankDuration: PropTypes.number.isRequired
      })).isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    quantitySuggestions: PropTypes.arrayOf(PropTypes.number),
    options: PropTypes.array
  };

  static defaultProps = {
    quantitySuggestions: [],
    options: []
  };

  static quantity = 1;

  static describeProductChoice = product => [product.rankRangeStart, product.rankRangeEnd].map(
    it => RankPickerContainer.describeRank(it, product.variant.rankCalculator)
  ).join(' → ');

  static calculateRangePrice = (basePrice, ranges, [selectedFrom, selectedTo]) => selectedTo < selectedFrom
    ? {selectedPrice: 0, selectedDuration: 0}
    : ranges.reduce((acc, range) => {
      if (selectedFrom > range.end || selectedTo < range.start) {
        return acc;
      }

      const currentRangeStart = selectedFrom > range.start ? selectedFrom : range.start;
      const currentRangeEnd = selectedTo < range.end ? selectedTo : range.end;
      const currentRangePart = currentRangeEnd - currentRangeStart;
      const totalRange = range.end - range.start;

      acc.selectedPrice += (currentRangePart / totalRange) * range.rangePrice;
      acc.selectedDuration += currentRangePart * range.rankDuration;

      return acc;
    }, {selectedPrice: basePrice, selectedDuration: 0});


  componentWillMount() {
    const {ranks} = this.props;
    this.onChange(RankPickerContainer.getDefaultValue(ranks), []);
  }

  componentWillReceiveProps(nextProps) {
    const {price, ranks, options} = nextProps;
    if (price !== this.props.price || ranks !== this.props.ranks || options !== this.props.options) {
      this.onChange(RankPickerContainer.getDefaultValue(ranks), []);
    }
  }

  getMinCost = () => this.props.ranks.minTotalCost || this.props.price;

  // TODO: add declensions for future russian translation
  getHumanReadableInterval = s => {
    const hour = 60 * 60;
    const day = hour * 24;

    let noun;
    let value;
    if (s < day) {
      noun = 'hour';
      value = s / hour;
    } else {
      noun = 'day';
      value = s / day;
    }

    value = Math.ceil(value);

    return `${value} ${noun}${value === 1 ? '' : 's'}`
  };

  onChange(rankValues, selectedOptions) {
    const {price: basePrice, options, ranks} = this.props;
    const {selectedPrice, selectedDuration} = RankCalculatorVariant.calculateRangePrice(basePrice, ranks.ranges, rankValues);
    const calculatedPrice = applyOptions(
      selectedPrice,
      RankCalculatorVariant.quantity,
      options.filter(it => selectedOptions.includes(it.id))
    );

    const calculatedDuration = applyOptions(
      selectedDuration,
      RankCalculatorVariant.quantity,
      options
        .filter(it => selectedOptions.includes(it.id))
        .filter(it => !!it.timing)
        .map(it => ({...it, pricing: it.timing}))
    );

    const newState = {
      rankValues,
      selectedOptions,
      selectedPrice,
      selectedDuration,
      calculatedPrice,
      calculatedDuration,
      error: calculatedPrice < this.getMinCost()
    };

    this.setState(newState);
    this.props.onCostChange(calculatedPrice);
    this.props.onChange({
      rankRangeStart: rankValues[0],
      rankRangeEnd: rankValues[1],
      options: selectedOptions,
      quantity: RankCalculatorVariant.quantity,
      error: newState.error
    });
  }

  render() {
    const {options, ranks} = this.props;
    const {selectedOptions, rankValues, selectedPrice, calculatedPrice, calculatedDuration, error} = this.state;

    return (
      <div className="product-variant product-variant--rank">
        <RankPickerContainer
          calculator={ranks}
          value={rankValues}
          onChange={value => this.onChange(value, selectedOptions)}
        />

        {options.length > 0 && (
          <ProductOptionsPicker
            basePrice={selectedPrice}
            quantity={RankCalculatorVariant.quantity}
            availableOptions={options}
            selectedOptionIds={selectedOptions}
            onChange={newOptions => this.onChange(rankValues, newOptions)}
          />
        )}

        <div className="product__price">
          <Pricing
            accented
            value={calculatedPrice}
          />
        </div>
        <div className="product-variant__notice">
          <FormattedMessage id="page.product.estimated"/>{':'}
          &nbsp;
          <span className="product-variant__notice-highlight">
            {this.getHumanReadableInterval(calculatedDuration)}
          </span>
        </div>
        {error && (
          <div className="product-variant__notice product-variant__notice--error">
            <FormattedMessage id="page.product.minimum"/>
            &nbsp;
            <span className="product-variant__notice-highlight product-variant__notice-highlight--error">
              <ChannelPrice price={this.getMinCost()}/>
            </span>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/RankCalculatorVariant.js